import { IClassname } from '@/lib/shared/model/classname';

export const Safe = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7446)">
        <path
          d="M3.86492 1.30371H28.1453C28.1453 1.30371 30.7012 1.30371 30.7012 3.85954V26.862C30.7012 26.862 30.7012 29.4179 28.1453 29.4179H3.86492C3.86492 29.4179 1.30908 29.4179 1.30908 26.862V3.85954C1.30908 3.85954 1.30908 1.30371 3.86492 1.30371Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.86499 29.418V30.6959"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.1453 29.418V30.6959"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 21.7506V23.0285C5.1377 23.7064 5.40697 24.3565 5.88628 24.8358C6.36559 25.3151 7.01568 25.5844 7.69353 25.5844H24.3064C24.9843 25.5844 25.6344 25.3151 26.1137 24.8358C26.593 24.3565 26.8623 23.7064 26.8623 23.0285V7.69353C26.8623 7.01568 26.593 6.36559 26.1137 5.88628C25.6344 5.40697 24.9843 5.1377 24.3064 5.1377H7.69353C7.01568 5.1377 6.36559 5.40697 5.88628 5.88628C5.40697 6.36559 5.1377 7.01568 5.1377 7.69353V8.97145"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.14282 12.8057V17.9173"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.86499 8.97168H6.42082V12.8054H3.86499V8.97168Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.86499 17.917H6.42082V21.7507H3.86499V17.917Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8936 15.361C10.8936 16.1162 11.0423 16.8639 11.3313 17.5616C11.6203 18.2593 12.0439 18.8933 12.5779 19.4273C13.1119 19.9613 13.7458 20.3849 14.4435 20.6739C15.1412 20.9629 15.889 21.1116 16.6442 21.1116C17.3994 21.1116 18.1472 20.9629 18.8448 20.6739C19.5425 20.3849 20.1765 19.9613 20.7105 19.4273C21.2445 18.8933 21.6681 18.2593 21.9571 17.5616C22.2461 16.8639 22.3948 16.1162 22.3948 15.361C22.3948 13.8358 21.7889 12.3731 20.7105 11.2947C19.632 10.2162 18.1693 9.61035 16.6442 9.61035C15.119 9.61035 13.6563 10.2162 12.5779 11.2947C11.4994 12.3731 10.8936 13.8358 10.8936 15.361Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4492 15.3608C13.4492 16.2081 13.7858 17.0207 14.385 17.6199C14.9841 18.219 15.7967 18.5556 16.644 18.5556C17.4913 18.5556 18.3039 18.219 18.9031 17.6199C19.5022 17.0207 19.8388 16.2081 19.8388 15.3608C19.8388 14.5135 19.5022 13.7009 18.9031 13.1017C18.3039 12.5026 17.4913 12.166 16.644 12.166C15.7967 12.166 14.9841 12.5026 14.385 13.1017C13.7858 13.7009 13.4492 14.5135 13.4492 15.3608Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.644 9.61035V12.1662"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5776 11.2949L14.3846 13.1032"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8936 15.3613H13.4494"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5776 19.4271L14.3846 17.6201"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.644 21.1115V18.5557"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7103 19.4284L18.9033 17.6201"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3947 15.3613H19.8389"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7103 11.2949L18.9033 13.1032"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7446">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
